"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Fab = _interopRequireDefault(require("@mui/material/Fab"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Abstraction of Material UI's `Fab`
 * 
 * Original author @heron-web/material (no longer maintained)
 */const Fab = props => {
  /**
   * Clicked.
   * 
   * @return {void}
   */
  const handleClick = () => props.onClick?.(props.value, props.name);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Fab.default, {
    className: props.className,
    color: props.color,
    disabled: props.disabled,
    onClick: handleClick,
    size: props.size,
    variant: props.variant,
    children: props.children
  });
};
Fab.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(["primary", "secondary", "inherit"]),
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.elementType,
  name: _propTypes.default.string,
  onClick: _propTypes.default.func,
  size: _propTypes.default.oneOf(["small", "medium", "large"]),
  variant: _propTypes.default.oneOf(["round", "extended"]),
  value: _propTypes.default.any
};
Fab.defaultProps = {
  color: "primary",
  disabled: false,
  size: "large",
  variant: "round"
};
var _default = exports.default = Fab;